import { setStyles } from 'app/core/graphics/Style';
import { compilePath } from 'app/core/rendering/compiler';
export const renderHighlightMarker = (marker, opts, ctx) => {
    const item = marker;
    const painter = compilePath(item.data);
    const { globalAlpha } = ctx;
    ctx.globalAlpha = 0.35;
    ctx.save();
    ctx.translate(item.x, item.y);
    setStyles(ctx, {
        strokeCap: 'butt',
        strokeJoin: 'round',
        strokeWidth: marker.size,
        strokeColor: marker.color,
    });
    ctx.beginPath();
    painter(ctx);
    ctx.stroke();
    ctx.restore();
    ctx.globalAlpha = globalAlpha;
};
